/* eslint max-classes-per-file: 0 */

import {
  Scheduler as Data,
  SchedulerCollection as Collection,
} from '@/typings/api/Scheduler'
import { SchedulerApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'

const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class SchedulerTransformerParams extends TransformerParams {
}

export class SchedulerAdapter extends Adapter<Api> {
    public readonly api = new Api();

    public readonly transformerParams = new SchedulerTransformerParams();
}
